<template>
  <div>
    <el-container class="home-container">
      <!-- 头部 -->
      <el-header
        v-if="isShow.header"
        style="background: #23262e; font-size: 0; padding: 0"
      >
        <div style="display: flex; flex-direction: row">
          <div
            style="
              width: 200px;
              height: 60px;
              font-size: 16px;
              line-height: 60px;
              color: #fff;
              text-align: center;
            "
            @click="throwError"
          >
            一手 ERP
          </div>

          <div>
            <el-button
              type="text"
              style="height: 60px; color: white"
              @click="Collapse"
            >
              <i v-if="isCollapse" class="el-icon-d-arrow-right" />
              <i v-else class="el-icon-d-arrow-left" />
            </el-button>
          </div>

          <div class="header-bar">
            <el-dropdown
              style="
                padding: 0 20px;
                color: #fff;
                height: 100%;
                line-height: 60px;
                cursor: pointer;
              "
              trigger="click"
              @command="handleCommand"
            >
              <span class="el-dropdown-link">
                {{ username }}
                <i class="el-icon-arrow-down el-icon--right" />
              </span>
              <template #dropdown>
                <el-dropdown-menu>
                  <el-dropdown-item divided command="logout">
                    退出登录
                  </el-dropdown-item>
                </el-dropdown-menu>
              </template>
            </el-dropdown>
            <div class="header-bar">
              <el-button
                v-if="storehouse"
                class="header-storehouse"
                type="text"
                style="line-height: 1"
                @click="isShowDialogMobilize = true"
              >
                所属仓库：{{ storehouse }}
              </el-button>
              <el-button
                type="text"
                style="height: 60px; color: white; font-size: 20px"
                @click="showDownload"
              >
                <i class="el-icon-download" />
              </el-button>
            </div>
          </div>
        </div>
      </el-header>
      <el-container>
        <!-- 侧边菜单 -->
        <el-aside v-if="isShow.menu" class="home-aside" width>
          <el-menu
            id="homeElMenu"
            ref="menuRef"
            style="border: 0"
            class="el-menu-vertical-demo self-menu"
            background-color="#23262E"
            text-color="#fff"
            active-text-color="#f13685"
            :collapse="isCollapse"
            :default-active="defaultActive"
            unique-opened
            @select="handleSelect"
          >
            <div
              v-if="!isCollapse"
              class="search"
              :style="{
                'justify-content': isCollapse ? 'center' : 'flex-start',
              }"
            >
              <el-input
                id="searchKey"
                v-model="searchKey"
                :clearable="true"
                type="text"
                prefix-icon="el-icon-search"
                placeholder="搜索菜单"
                style="font-size: 13px"
              />
              <div class="search-kbd-wrap">
                <kbd class="search-kbd">{{ searchKeyAbdText }}</kbd>
                <kbd class="search-kbd">K</kbd>
              </div>
            </div>
            <div v-else class="search-icon">
              <i class="el-icon-search" @click="handleCollapsedChange(false)" />
            </div>
            <el-submenu
              v-for="pmenu in searchMenuList || menu"
              :key="pmenu.label"
              :index="pmenu.id.toString()"
            >
              <template #title>
                <i
                  v-if="pmenu.label == '权限管理'"
                  class="el-icon-alizhanghaoquanxianguanli"
                />
                <i
                  v-if="pmenu.label == '代采管理'"
                  class="el-icon-alicaigou-xianxing"
                />
                <i
                  v-if="pmenu.label == '仓储管理'"
                  class="el-icon-alicangkucangchu-xianxing"
                />
                <i
                  v-if="pmenu.label == '财务管理'"
                  class="el-icon-alicaiwu-xianxing"
                />
                <i
                  v-if="pmenu.label == '商家管理'"
                  class="el-icon-alihezuoguanxi-xianxing"
                />
                <i
                  v-if="pmenu.label == '数据表格管理'"
                  class="el-icon-alitubiao-zhuzhuangtu"
                />
                <i
                  v-if="pmenu.label == '业务监控'"
                  class="el-icon-alishujukanban"
                />
                <i
                  v-if="pmenu.label == '配置管理'"
                  class="el-icon-aliicon_shezhi"
                />
                <i
                  v-if="pmenu.label == '买手部管理'"
                  class="el-icon-aliquanxianshenpi"
                />
                <i v-if="pmenu.label == '消息公告'" class="el-icon-bell" />
                <i v-if="pmenu.label == '售后工单'" class="el-icon-tickets" />
                <i
                  v-if="pmenu.label == '商家消息通知'"
                  class="el-icon-message"
                />
                <i v-if="pmenu.label == '商家权限管理'" class="el-icon-key" />
                <span>{{ pmenu.label }}</span>
              </template>
              <!--<el-menu-item-group>-->
              <template v-for="cmenu in pmenu.children">
                <el-submenu
                  v-if="cmenu.children != undefined"
                  :key="pmenu.id.toString() + '-' + cmenu.id.toString()"
                  class="submenu2"
                  :index="cmenu.id.toString()"
                >
                  <template v-if="cmenu.children != undefined" #title>{{
                    cmenu.label
                  }}</template>
                  <template v-for="ccmenu in cmenu.children">
                    <el-menu-item
                      v-if="cmenu.children != undefined"
                      :key="ccmenu.id.toString()"
                      :index="ccmenu.link"
                      >{{ ccmenu.label }}</el-menu-item
                    >
                  </template>
                </el-submenu>
                <el-menu-item
                  v-if="cmenu.children == undefined"
                  :key="cmenu.id.toString()"
                  :index="cmenu.link"
                  >{{ cmenu.label }}</el-menu-item
                >
              </template>
              <!--</el-menu-item-group>-->
            </el-submenu>
          </el-menu>
        </el-aside>
        <!-- 内容 -->
        <el-main
          v-loading="$store.getters.loading"
          class="el-main"
          style="padding: 0"
        >
          <div v-if="editableTabs && editableTabs.length" class="tag-view">
            <div>
              <el-tag
                v-for="tag in editableTabs"
                :key="tag.name"
                :effect="editableTabsValue === tag.name ? 'dark' : 'plain'"
                style="margin: 5px; cursor: pointer"
                closable
                type="primary"
                @click="openNav(tag.name)"
                @close="removeTab(tag.name)"
                >{{ tag.title }}</el-tag
              >
            </div>
            <el-dropdown @command="handleCommand">
              <el-button icon="el-icon-close" size="small"></el-button>
              <template #dropdown>
                <el-dropdown-menu>
                  <el-dropdown-item command="closeAllTag"
                    >关闭全部</el-dropdown-item
                  >
                  <el-dropdown-item command="closeOthersTag"
                    >关闭其他</el-dropdown-item
                  >
                </el-dropdown-menu>
              </template>
            </el-dropdown>
          </div>
          <div style="margin: 15px">
            <keep-alive :exclude="uncachedRouteNames">
              <router-view :key="$route.fullPath"></router-view>
            </keep-alive>
          </div>
        </el-main>
      </el-container>
    </el-container>
    <el-dialog
      :visible="isShowDialogDownload"
      width="80%"
      top="20"
      :before-close="closeDownload"
    >
      <template #title>
        下载列表
        <span style="color: red">(下次刷新倒计时:{{ flashTime }})</span>
      </template>
      <el-table :data="files" style="width: 100%" height="500">
        <el-table-column
          fixed
          prop="id"
          label="id"
          width="50"
        ></el-table-column>
        <el-table-column
          prop="title"
          label="任务名"
          width="150"
        ></el-table-column>
        <el-table-column
          prop="total_num"
          label="数据总数"
          width="100"
        ></el-table-column>
        <el-table-column label="进度" width="300">
          <template #default="scope">
            <el-progress
              :percentage="parseInt(scope.row.progress)"
              :status="scope.row.down_status == 1 ? 'success' : ''"
            ></el-progress>
          </template>
        </el-table-column>
        <el-table-column
          prop="admin_name"
          label="管理员"
          width="80"
        ></el-table-column>
        <el-table-column
          prop="create_time"
          label="导出时间"
          width="160"
        ></el-table-column>
        <el-table-column label="下载链接" width="200">
          <template #default="scope">
            <el-button
              v-if="scope.row.canDown == 1"
              type="success"
              size="mini"
              @click="downloadFile(scope.row.fileurl)"
              >下载</el-button
            >
            <span v-if="scope.row.canDown == 0" style="color: red">
              {{ scope.row.filename }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="状态" width="100">
          <template #default="scope">
            <span v-if="scope.row.down_status == 0">导出中</span>
            <span v-if="scope.row.down_status == 1" style="color: green">
              已完成
            </span>
            <span v-if="scope.row.down_status == 9" style="color: red">
              错误
            </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="error_msg"
          label="错误信息"
          width="200"
          style="color: red"
        ></el-table-column>
        <el-table-column label="操作">
          <template #default="scope">
            <el-button
              v-if="scope.row.down_status == 0"
              size="mini"
              type="danger"
              @click="stopTask(scope.row)"
              >停止</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>

    <DialogMobilize
      v-model="isShowDialogMobilize"
      :search-params="{ admin_name: username }"
    />
  </div>
</template>

<script>
import { cloneDeep } from "lodash-es";
import Vue from "vue";
import Cookie from "vue-cookie";
import { mapGetters } from "vuex";
import DialogMobilize from "@/pages/WarehouseWorkerList/components/DialogMobilize.vue";
import Global_ from "../components/Global.vue";

const isInclude = (menu, searchKey) => {
  const text = searchKey.toLowerCase().replace(/\s+/g, "");
  const includesText = (str) => (str || "").toLowerCase().includes(text);

  if (includesText(menu.label) || includesText(menu.pinyin)) {
    return true;
  }

  if (Array.isArray(menu.children)) {
    const filteredChildren = menu.children.filter((item) =>
      isInclude(item, searchKey)
    );
    // eslint-disable-next-line no-param-reassign
    menu.children = filteredChildren;
    return filteredChildren.length > 0;
  }

  return false;
};
export default {
  name: "Home",
  components: {
    DialogMobilize,
  },
  // Fetch menu data before entering route
  beforeRouteEnter(to, from, next) {
    return Vue.axios.post("/erp/Common/getErpMenu", {}).then((res) => {
      const { code } = res.data;

      // Handle unauthorized access
      if (code === 201) {
        return from.path === "/"
          ? next(new Error("请先登录"))
          : next({ path: "/", replace: true });
      }

      // Handle other error codes
      if (code !== 200) {
        return next(false);
      }

      // Initialize component with menu data
      return next((vm) => {
        vm.initializeMenuData(res);
        vm.$store.dispatch("getObsUploadData");

        // Preserve tab after refresh
        vm.$nextTick(() => {
          vm.autoAddTab(to, from);
        });
      });
    });
  },
  beforeRouteUpdate(to, from, next) {
    this.autoAddTab(to, from);
    next();
  },
  data() {
    return {
      uncachedRouteNames: [
        "stock/stock-out-order-detail",
        "ReturnOrderEdit",
        "PreStockPlanEdit",
        "preStockPlanEdit",
      ],
      componentsName: "home", // home.vue的唯一标识
      isCollapse: false,
      activeIndex: "1",
      activeIndex2: "1",
      menu: null,
      username: "",
      storehouse: "", // 所属仓库
      default: ["1"],
      editableTabsValue: "2",
      editableTabs: [],
      tabIndex: 0,

      tabStyle: "top:60px;",
      files: [],
      timer: null,
      flashTime: 10,
      defaultActive: "",
      // tabButtonMap: {}, // 上面那个导航栏的映射 url => pids
      menu_map: {}, // 平铺的菜单映射
      // 不需要显示菜单的页面
      hide_menu_page_route_name: [
        "serviceOrderCreate",
        "PickingTaskPrint",
        "screenboard",
      ],
      searchKey: "",
      searchMenuList: null,
      timer2: null,
      searchKeyAbdText: "ctrl",
      inputDisabled: true,
      isShowDialogMobilize: false,
      osHost: "",
    };
  },
  computed: {
    shouldHideMenuAndHeader() {
      return this.hide_menu_page_route_name.includes(this.$route.name);
    },
    isShow() {
      return {
        menu: !this.shouldHideMenuAndHeader,
        header: !this.shouldHideMenuAndHeader,
      };
    },
    ...mapGetters({
      isShowDialogDownload: "isShowDialogDownload",
    }),
  },
  watch: {
    isShowDialogDownload: {
      handler(val) {
        if (val) {
          this.getDownloadList();
          this.timer = setInterval(() => {
            this.flashTime -= 1;
            if (this.flashTime === 0) {
              this.getDownloadList();
              this.flashTime = 10;
            }
          }, 1000);
        } else {
          this.flashTime = 10;
          clearInterval(this.timer);
        }
      },
    },
    searchKey(val) {
      this.searchMenuList = val
        ? cloneDeep(this.menu).filter((menuItem) =>
            isInclude(menuItem, this.searchKey)
          )
        : this.menu;
    },
    defaultActive: {
      handler() {
        clearTimeout(this.timer2);
        this.timer2 = setTimeout(() => {
          const node = document
            .getElementById("homeElMenu")
            .getElementsByClassName("el-menu-item is-active")[0];
          if (node) {
            node.scrollIntoView({
              block: "center",
              behavior: "smooth",
            });
          }
        }, 300);
      },
    },
  },
  created() {
    document.addEventListener("keydown", this.focusSearchInput);
    this.osHost = localStorage.getItem("osHost") || "";
    if (!this.osHost) {
      this.osHost = "http://osweb-main.yishou.com";
      localStorage.setItem("osHost", "http://osweb-main.yishou.com");
    }
    this.getPosType();
    this.watchUserChange();
    // this.hideMenuAndHeader();
    this.listenTabEvent();
  },
  beforeDestroy() {
    clearInterval(this.timer);
    clearTimeout(this.timer2);
    document.removeEventListener("keydown", this.focusSearchInput);
  },
  methods: {
    // 快捷键聚焦搜索框
    focusSearchInput() {
      const isKeyboardK = window?.event?.key === "k";
      const isMacCommand = window?.event?.metaKey; // max
      const isWindowCtrl = window?.event?.ctrlKey; // window
      if ((isKeyboardK && isMacCommand) || (isKeyboardK && isWindowCtrl)) {
        window.event.preventDefault(); // 屏蔽window浏览器组合键 ctrl+k
        document.getElementById("searchKey").focus();
      }
    },
    // 获取系统、浏览器信息
    getPosType() {
      const agent = navigator.userAgent.toLowerCase();
      const isMac = /macintosh|mac os x/i.test(agent);
      this.searchKeyAbdText = isMac ? "⌘" : "ctrl";
    },
    throwError() {
      throw new Error(`new error at ${Date.now()}`);
    },
    // 点击菜单
    addTabButton(nav) {
      // 检查标签是否已存在
      const tabExists = this.editableTabs.some(
        (tab) => tab.content === nav.link
      );

      if (!tabExists) {
        this.editableTabs.push({
          title: nav.label,
          name: nav.link,
          content: nav.link,
        });
      }

      this.editableTabsValue = nav.link;
      this.menuActive(nav.link);
    },
    // 关闭导航栏
    removeTab(targetName) {
      // Find new active tab if current one is being removed
      let activeName = this.editableTabsValue;
      if (activeName === targetName) {
        const currentIndex = this.editableTabs.findIndex(
          (tab) => tab.name === targetName
        );
        const nextTab =
          this.editableTabs[currentIndex + 1] ||
          this.editableTabs[currentIndex - 1];
        activeName = nextTab ? nextTab.name : "";
      }

      // Update tabs state and handle navigation in one pass
      this.editableTabsValue = activeName;
      this.editableTabs = this.editableTabs.filter(
        (tab) => tab.name !== targetName
      );

      // Defer component cleanup to next tick to avoid blocking UI
      this.$nextTick(() => {
        if (this.editableTabs.length) {
          this.openNav(this.editableTabs[this.editableTabs.length - 1].name);
        } else {
          this.openNav("");
        }
      });

      // Let Vue's built-in cleanup handle component destruction
      // This avoids manual component traversal and destruction
    },
    /**
     * Handle navigation tab click event
     * @param {string|object} name - Tab name or tab object
     */
    openNav(name) {
      // Reset search key when menu changes since original menu items may no longer exist
      this.searchKey = "";

      this.$nextTick(() => {
        // Convert string name to object format if needed
        const nameObj =
          typeof name === "string"
            ? {
                $options: {
                  propsData: { name },
                },
              }
            : name;

        const routePath = nameObj.$options.propsData.name;

        // Special handling for wave picking device cut page - add random param to force refresh
        if (routePath === "/wavepicking/devicecut") {
          const randomParam = Math.random(1000, 9999);
          this.$router.push(`/home${routePath}?r=${randomParam}`);
        } else {
          // Normal navigation
          this.$router.push(`/home${routePath}`);
        }

        // Update active menu item
        this.menuActive(routePath);
      });
    },

    // 选中菜单栏里面的对应的选项
    menuActive(uri) {
      if (this.isCollapse) {
        return;
      }

      const menuMap = this.menu_map[uri];
      if (!menuMap?.pids?.length) {
        this.defaultActive = uri;
        return;
      }
      this.defaultActive = uri;
    },

    /**
     * Automatically adds a navigation tab when route changes (via update or enter)
     * @param {Object} toRouteItem - The target route object containing route information
     * @returns {void}
     */
    autoAddTab(toRouteItem) {
      if (this.shouldHideMenuAndHeader) {
        return;
      }

      const link = this.removeHomePrefix(toRouteItem.fullPath);
      if (!link) {
        return;
      }

      let title = toRouteItem.meta.title || "未命名页面";
      const { title: menuTitle } = this.menu_map[link] || {};
      title = menuTitle || title;

      this.addTabButton({
        label: title,
        link,
      });
    },

    Collapse() {
      this.isCollapse = !this.isCollapse;
    },

    // 从URI中移除/home前缀
    removeHomePrefix(uri) {
      return uri.replace("/home", "");
    },

    handleSelect(key, keyPath) {
      this.default = keyPath;
      // 分播列表自动刷新,需要用随机数
      if (key === "/wavepicking/devicecut") {
        this.$router.push(`/home${key}?r=${Math.random(1000, 9999)}`);
      } else {
        this.$router.push(`/home${key}`);
      }
    },
    handleCommand(command) {
      const func = {
        logout: () => {
          const url = "/erp/admin/logoutToSite";
          this.$http.post(url).then((res) => {
            if (res.data.code !== 200) {
              this.$message.error("登出失败,请联系管理员");
            } else {
              Cookie.set("deskNo", "");
              Cookie.set("deskNoCheck", "");
              Cookie.set("boxNo", "");
              Cookie.set("PcQualityCheckType", "");
              if (this.$route.fullPath !== "/") {
                this.$router.replace("/");
              }
            }
          });
        },
        roleAdministration: () => {
          this.$router.push("/home/adminroletree");
        },
        groupAdministration: () => {
          this.$router.push("/home/admingrouptree");
        },
        roleAdminList: () => {
          this.$router.push("/home/adminlist");
        },
        roleAdminListToGroup: () => {
          this.$router.push("/home/adminlisttogroup");
        },
        closeAllTag: () => {
          this.editableTabs = [];
          this.editableTabsValue = "";
          this.openNav("");
        },
        closeOthersTag: () => {
          this.editableTabs = this.editableTabs.filter(
            (tab) => tab.name === this.editableTabsValue
          );
        },
      };
      if (func[command]) {
        func[command]();
      }
    },
    initializeMenuData(res) {
      const { code, msg, data } = res.data;
      if (code !== 200) {
        return this.$message.error(msg);
      }

      this.menu = data;
      this.$nextTick(this.initializeMenuStructure);
      return true;
    },

    /**
     * Initializes menu structure by:
     * 1. Building parent-child relationships
     * 2. Setting active menu based on current route
     * 3. Creating flattened menu map for O(1) lookups
     */
    initializeMenuStructure() {
      const path = this.removeHomePrefix(this.$route.path);

      const processMenuItems = (items = [], parentIds = []) => {
        items.forEach((item) => {
          // Create a new object instead of modifying the parameter
          const menuItem = {
            ...item,
            pids: item.pids || [...parentIds, item.id],
          };

          // Use menuItem for the rest of the logic
          if (menuItem.link === path) {
            this.menuActive(menuItem.link);
          }

          this.menu_map[menuItem.link] = {
            pids: menuItem.pids,
            title: menuItem.label,
          };

          if (menuItem.children?.length) {
            processMenuItems(menuItem.children, menuItem.pids);
          }
        });
      };

      processMenuItems(this.menu);
    },

    showDownload() {
      this.$store.commit("TOGGLE_DOWNLOAD_DIALOG", true);
    },
    closeDownload() {
      this.$store.commit("TOGGLE_DOWNLOAD_DIALOG", false);
    },
    /**
     * 获取导出任务列表
     */
    getDownloadList() {
      this.$http.post("/erp/DownloadTask/lst").then((res) => {
        if (String(res.data.code) !== "200") {
          this.closeDownload();
          this.$message.error(res.data.msg);
        } else {
          this.files = res.data.data.list;
        }
      });
    },
    stopTask(row) {
      this.$http
        .post("/erp/DownloadTask/stopTask", {
          id: row.id,
        })
        .then((res) => {
          if (res.data.code !== 200) {
            this.$message.e(res.data.msg);
          } else {
            this.$message.success("终止成功");
            this.showDownload();
          }
        });
    },
    openBoard() {
      this.downloadFile(
        Number(Global_.environment) === 0
          ? "/#/home/monitor/board"
          : "/erp/#/home/monitor/board"
      );
    },
    downloadFile(fileurl) {
      window.open(fileurl);
    },

    // / 监听cookie的变化, 获取并更新正确的user_name
    watchUserChange() {
      this.username = this.$cookie.get("username");
      this.storehouse = this.$cookie.get("storehouse_name");
      const timer = setInterval(() => {
        this.username = this.$cookie.get("username");
        // 没有找到cookie的用户名, 自动跳转到登陆页面
        if (!this.username) {
          clearInterval(timer); // 清除计时器
          this.handleCommand("logout");
        }
      }, 10000);
    },
    handleCollapsedChange(state) {
      this.isCollapse = state;
      if (state) {
        this.searchKey = "";
      }
    },
    listenTabEvent() {
      /**
       * TODO 全局移除tag的方法，目前先这样处理，后面放到vuex优化处理
       * */
      this.$bus.$on("removeTab", this.removeTab);
      this.$once("hook:beforeDestroy", () => {
        this.$bus.$off("removeTab");
      });
    },
  },
};
</script>
<style>
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 180px;
  height: 100%;
  overflow-y: auto;
}

.el-menu-vertical-demo::-webkit-scrollbar {
  width: 0;
  height: 0;
}

.el-menu-item.is-active {
  background: #1c1e25 !important;
}

.header_tab .el-tabs__header {
  margin-bottom: 0 !important;
}
</style>
<style scroped lang="css">
*::-webkit-scrollbar {
  width: 8px;
  height: 8px;
  background-color: #ccc;
  border-radius: 8px;
}

*::-webkit-scrollbar-thumb {
  background-color: #999;
  border-radius: 8px;
}

.tag-view {
  position: sticky;
  top: 0;
  background: #fff;
  z-index: 99;
  border-bottom: 1px solid #eee;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}

.home-container {
  height: 100vh;
}

.home-aside {
  background: #23262e;
  height: calc(100vh - 60px);
  overflow: auto;
}

.home-aside::-webkit-scrollbar {
  width: 0;
  height: 0;
}

.el-main {
  padding: 0;
  width: 100%;
  height: calc(100vh - 60px);
  overflow: auto;
}

.home-menu {
  height: 100%;
}

.el-menu-item-group__title {
  padding: 0;
}

.search {
  /* width: 180px; */
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 10px;
  position: sticky;
  top: 0;
  z-index: 999;
  background: rgb(35, 38, 46);
}

.search-icon {
  color: #909399;
  background-color: rgb(35, 38, 46);
  padding: 0 20px;
  font-size: 14px;
  transition: border-color 0.3s, background-color 0.3s, color 0.3s;
  height: 56px;
  line-height: 56px;
}

.search-icon .el-icon-search {
  margin: 0;
  vertical-align: middle;
  width: 24px;
  text-align: center;
  font-size: 18px;
}

.header-bar {
  flex: 1;
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
}

.header-storehouse {
  margin-left: 20px;
  height: 60px;
  line-height: 60px;
  font-size: 14px;
  color: #fff;
}

.search-kbd-wrap {
  align-items: center;
  display: flex;
  gap: 4px;
  height: 100%;
  justify-content: center;
  pointer-events: none;
  position: absolute;
  right: 16px;
  top: 0;
}

.search-kbd {
  background-color: #fff;
  border: 1px solid #bec3c9;
  box-shadow: inset 0 -1px 0 #bec3c9;
  color: #bec3c9;
  border-radius: 0.2rem;
  padding: 0.12rem 0.26rem;
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  appearance: none;
  margin: 0;
}

/* Firefox */
input[type="number"] {
  appearance: textfield;
}

/* 菜单名称过长 */
.el-submenu .el-menu .el-menu-item,
.submenu2 > .el-submenu__title {
  word-break: break-all;
  white-space: break-spaces;
  line-height: 20px;
  display: flex;
  align-items: center;
}

.submenu2 > .el-submenu__title {
  padding-right: 30px;
}
</style>



// WEBPACK FOOTER //
// src/pages/Home.vue